import React from 'react';
import { Tooltip } from '@/components/tooltip';

interface ColumnTooltipIconProps {
  text: string | null;
}

export function ColumnTooltipIcon({ text }: ColumnTooltipIconProps) {
  if (!text) {
    return <div style={{ width: `1rem` }} />;
  }

  return (
    <span role="presentation">
      <Tooltip text={text} zIndex={10000000} />
    </span>
  );
}
